import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { PeepingLogo } from "@/components/PeepingLogo";
import { BG_IMAGE } from "@/lib/demoImages";
import { Checkbox } from "@/components/ui/checkbox";

export default function Welcome() {
  const [confirmed, setConfirmed] = useState(false);
  const navigate = useNavigate();

  const enter = () => {
    if (!confirmed) return;
    localStorage.setItem("peeping_age_ok", "1");
    navigate("/register");
  };

  return (
    <div
      data-testid="welcome-screen"
      className="relative min-h-screen overflow-hidden bg-[#080808] grain flex flex-col"
    >
      {/* Photographic brand band (top only) — wordmark-free crop so the logo is never duplicated */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[46vh] overflow-hidden">
        <img
          src={BG_IMAGE}
          alt=""
          aria-hidden
          className="h-full w-full object-cover object-top opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#080808]/10 via-[#080808]/70 to-[#080808]" />
      </div>
      <div className="pointer-events-none absolute top-8 right-0 h-56 w-56 glow-magenta opacity-40" />

      <div className="relative z-10 mx-auto flex w-full max-w-md flex-1 flex-col items-center justify-end px-6 pb-10 pt-24">
        <div className="animate-fade-up flex flex-col items-center">
          <PeepingLogo className="w-56" />

          <div className="my-7 h-px w-14 bg-gradient-to-r from-transparent via-[#d42be8] to-transparent" />

          <label className="flex items-start gap-3 text-center text-sm text-white/85 cursor-pointer max-w-xs">
            <Checkbox
              checked={confirmed}
              onCheckedChange={(v) => setConfirmed(!!v)}
              data-testid="age-confirm-checkbox"
              className="mt-0.5 border-white/40 data-[state=checked]:bg-[#d42be8] data-[state=checked]:border-[#d42be8]"
            />
            <span className="text-left leading-snug">
              I confirm that I am 18 years of age or older and wish to enter.
            </span>
          </label>

          <button
            onClick={enter}
            disabled={!confirmed}
            data-testid="welcome-enter-btn"
            className="btn-brand mt-7 w-full max-w-xs rounded-2xl py-4 text-base font-semibold text-white"
          >
            ENTER
          </button>

          <p className="mt-5 max-w-xs text-center text-[0.68rem] leading-relaxed text-[#a7a0af]">
            This site contains adult-oriented content and is intended for individuals 18+ only.
            This is a self-declaration, not verified proof of age.
          </p>

          <div className="mt-5 flex items-center gap-4 text-[0.68rem] text-[#a7a0af]">
            <Link to="/legal/terms" data-testid="link-terms" className="underline underline-offset-4 hover:text-white">
              Terms of Service
            </Link>
            <span className="opacity-30">|</span>
            <Link to="/legal/privacy" data-testid="link-privacy" className="underline underline-offset-4 hover:text-white">
              Privacy Policy
            </Link>
          </div>

          <div className="mt-6 text-center text-sm text-white/80">
            <Link to="/register" data-testid="welcome-register-link" className="font-semibold text-[#d42be8]">
              Create an account
            </Link>
            <span className="mx-2 opacity-30">·</span>
            <Link to="/login" data-testid="welcome-login-link" className="font-semibold text-white">
              Log in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
